import React from 'react';
import CookieConsent from '~/components/CookieConsent';
import Footer from '~/components/layout/Footer';
import Header from '~/components/layout/Header';

interface SimpleLayoutProps extends React.HTMLAttributes<HTMLDivElement> {}

const SimpleLayout = ({ children }: SimpleLayoutProps) => {
  return (
    <div className="relative flex min-h-dvh flex-col">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default SimpleLayout;
